var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-5 md:mb-15 2xl:mb-20"
  }, [_c('div', {
    staticClass: "border border-gray-600 border-dashed rounded xxl:mx-20 2xl:mx-40"
  }, [_c('p', {
    staticClass: "text-base text-center my-8 uppercase"
  }, [_vm._v("\n      Modèle de page\n    ")]), _vm._v(" "), _vm.evaluationInProgress ? _c('p', {
    staticClass: "text-base text-center my-8 uppercase text-pink-600"
  }, [_vm._v("\n      Modification impossible : évaluation en cours sur ce modèle de page.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb-8 flex flex-col md:flex-row justify-center items-center space-y-1.5 md:space-x-5"
  }, [_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_APERCU) ? _c('action-button', {
    attrs: {
      "id": "tour_visualiser",
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-orange-300",
      "bg-color-square": "bg-orange-100",
      "icon-color": "text-orange-600",
      "libelle": "Visualiser",
      "icon": "eye"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.showPreview();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_MODELE_DE_PAGE) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-teal-300",
      "bg-color-square": "bg-teal-100",
      "icon-color": "text-teal-600",
      "libelle": "Attribuer",
      "icon": "people"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.assignTemplate();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.isActive == 1 && !_vm.evaluationInProgress && _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-indigo-300",
      "bg-color-square": "bg-indigo-100",
      "icon-color": "text-indigo-600",
      "libelle": "Désactiver",
      "icon": "power"
    },
    on: {
      "clickAction": _vm.deactivateTemplate
    }
  }) : _vm.isActive == 0 && !_vm.evaluationInProgress && _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-pink-300",
      "bg-color-square": "bg-pink-100",
      "icon-color": "text-pink-600",
      "libelle": "Activer",
      "icon": "power"
    },
    on: {
      "clickAction": _vm.activateTemplate
    }
  }) : _vm._e(), _vm._v(" "), !_vm.evaluationInProgress && _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_SUPPRIMER) && _vm.canDelete ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-gray-300",
      "bg-color-square": "bg-gray-100",
      "icon-color": "text-gray-600",
      "libelle": "Supprimer",
      "icon": "trash-2"
    },
    on: {
      "clickAction": _vm.confirmDeleteTemplate
    }
  }) : _vm._e()], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }